import {
  GET_FINALITY_LOGS_PENDING,
  GET_FINALITY_LOGS_SUCCESS,
  GET_FINALITY_LOGS_ERROR,
  RESET_GET_FINALITY_LOGS,
  GetFinalityLogsState,
  GetFinalityLogsActionType,
} from "./types";

const initialState: GetFinalityLogsState = {
  getFinalityLogsPending: false,
  getFinalityLogsError: false,
  getFinalityLogsResponse: null
}

export function GetFinalityLogsReducer(
  state: GetFinalityLogsState = initialState,
  action: GetFinalityLogsActionType
): GetFinalityLogsState {
  switch (action.type) {

    case GET_FINALITY_LOGS_PENDING: {
      return {
        ...state,
        getFinalityLogsPending: true,
      };
    }

    case GET_FINALITY_LOGS_SUCCESS: {
      const { payload } = action;
      const { response } = payload;

      return {
        ...state,
        getFinalityLogsPending: false,
        getFinalityLogsError: false,
        getFinalityLogsResponse: response
      };
    }

    case GET_FINALITY_LOGS_ERROR: {
      return {
        ...state,
        getFinalityLogsPending: false,
        getFinalityLogsError: true,
      };
    }

    case RESET_GET_FINALITY_LOGS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
